<template>
  <div id="app">
    <section class="section-hero small">
        <div class="container row">
            <div class="content">
                <h1>{{ title }}</h1>
            </div>
        </div>
    </section>
    <div class="container-fluid">
    <router-view :displayTooltip="displayTooltip" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';


export default {
  name: 'app',
  props: {
     
  },
  data() {
    return {
      title: 'Available Properties',
    }
  },
  created() {
    this.title = this.$route.meta.title;
    var userToken = this.getCookie('userToken');
    if (userToken != '') {
        if (!this.$store.state.loggedIn) {
            this.$store.commit('login', userToken);
        }
    }
  },
  methods: {
      displayTooltip(event) {
          event.preventDefault();
          var label = $(event.target).parent();
          var tooltip = $(label).find('.info');
          if ($(tooltip).hasClass('active')) {
              $(tooltip).removeClass('active');
          } else {
            $(tooltip).addClass('active');
            $(tooltip).attr('tabindex', '1');
            $(tooltip).focus();

          }
      },
      logout() {
        axios.post('/wp-json/HCLRC/v1/public-user-logout/'
        ).then(res => {
            this.$store.commit('logout');
            if (this.$route.query.logout) {
                window.location.href = '/available-properties/';
            } else {
            location.reload();

            }

        })
        .catch(function (error) {
            // if an error occurs, print that error
            console.log(error);

        });
    },
    includes(container, value) {
	    var returnValue = false;
	    var pos = container.indexOf(value);
	    if (pos >= 0) {
		    returnValue = true;
	    }
	    return returnValue;
    },
      getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
            c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
            }
        }
        return "";
    }
  },
  watch: {
    '$route' (to, from) {
      if (window.location.pathname == '/available-properties/') {
        this.title = 'Available Properties';
      } else {
        if (to.params.property_id) {
          this.title = to.meta.title + to.params.property_id
        } else {
          this.title = to.meta.title;
        }

      }
    }
  }
}

</script>


<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.property-grid {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding-left:0;

    
    @media screen and (max-width: 992px) {
        justify-content: center;
    }
}

.property-item {
        width: 325px;
        margin: 1.25rem 0;
        padding: .625rem;
        border: 1px solid rgba(39, 106, 166, .5);
        text-align: left;
        margin-right: 20px;
        text-transform: none;
        transition: all .25s ease-in-out;
        cursor: pointer;
        position: relative;

        .image {
            background-size: cover;
            min-height: 160px;
            width: 100%;
        }

        .featured {
            position: absolute;
            top: 20px;
            background-color: #DB3840;
            color: white;
            font-weight: 700;
            padding: .25rem 1rem;
            left: 0;
        }

        p {
            font-size: .875rem;
            margin-bottom: 0;
            font-family: "neue-haas-unica";

            &.address {
                font-weight: 700;
                font-size: 1rem;
                margin-top: .5rem;
                line-height: 24px;
                text-transform: capitalize;
                font-family: 'din-2014';
                &::before {
                        display: inline-block;
                        content: '';
                        width: .75rem;
                        height: .75rem;
                        border-radius: 1.25rem;
                        margin-right: .25rem;
                    }

                &.Residential {
                    &::before {
                        background-color: #fdbb48;
                    }
                }
                &.Commercial {
                    &::before {
                        background-color: #e53d51;
                    }
                }
                &.Industrial {
                    &::before {
                        background-color: #533278;
                    }
                }
            }
            &.price, &.neighborhood {
                font-weight: 500;
            }
            &.type {
                &::before {
                    display: inline-block;
                    content: '';
                    width: .5rem;
                    height: .5rem;
                    border-radius: 1.25rem;
                    margin-right: .25rem;
                }
                &.Residential {
                    color: #A56A02; // had to change for ADA
                    &::before {
                        background-color: #fdbb48;
                    }
                }
                &.Commercial {
                    color: #E22A40; // had to change for ADA
                    &::before {
                        background-color: #e53d51;
                    }
                }
                &.Industrial {
                    color: #533278;
                    &::before {
                        background-color: #533278;
                    }
                }
            }
           
        }
        &:hover {
            transition: all .25s ease-in-out;
            box-shadow: 0 0 6px rgba(39, 106, 166, .5);
        }
}
.error {
    background-color: #dc3b43;
    padding: 1rem;
    margin-bottom: 2rem;
    p {
        font-weight: 600;
        color: #fff;
        margin-bottom: 0;
    }
}

form.application, .info .item {
    p.price {
        display: inline;
    }
     .info {
        position: absolute;
        left: 0;
        display: none;
        border: 1px solid rgba(39, 106, 166, .5);
        background-color: #fff;
        padding: .5rem;
        width: 200px;
        line-height: 1.25rem;
        font-size: .825rem;
        z-index: 100;
        font-weight: 400;
        p {
            font-size: .825rem;
            line-height: 1.25rem;

        }
        &.large {
            width: 400px;
        }
        &.active {
            display: block;
        }
    }
    .infoLabel {
        position: relative;
        display: inline;
        margin-right: .5rem;
        button {
            border: none;
        }
    }

    .form-item {
        margin-bottom: 1.5rem;
        p.warning {
            display: none;
        }
        &.warning {
            border: 1px solid #DC3B43;
            padding: 1rem;
            p.warning {
                display: block;
                font-weight: 700;
                color: #DC3B43;
            }
        }
         a {
            text-transform: none;
            color: #DC3B43;
        }
        &.file-upload {
            padding: 1rem;
            i {
                font-size: .75rem;
                margin-right: .25rem;
            }
        }
    }
}
.application-button-container {
        text-align: center;
        margin-top: 3rem;
        p.disclaimer {
            text-align: center;
        }
    }

</style>



// WEBPACK FOOTER //
// src/App.vue